<template>
  <section class="section-card" :class="{ 'section-card--flush': flush }">
    <header
      v-if="title || subtitle || $slots.title || $slots.headerActions"
      class="section-card__header"
    >
      <div class="section-card__heading">
        <h2 v-if="title" class="section-card__title">{{ title }}</h2>
        <slot v-else name="title" />
        <p v-if="subtitle" class="section-card__subtitle">{{ subtitle }}</p>
      </div>
      <div v-if="$slots.headerActions" class="section-card__header-actions">
        <slot name="headerActions" />
      </div>
    </header>

    <div class="section-card__body">
      <slot />
    </div>

    <footer v-if="$slots.actions" class="section-card__actions">
      <slot name="actions" />
    </footer>
  </section>
</template>

<script>
export default {
  name: "SectionCard",
  props: {
    title: { type: String, default: "" },
    subtitle: { type: String, default: "" },
    flush: { type: Boolean, default: false },
  },
};
</script>

<style scoped lang="scss">
.section-card {
  position: relative;
  background-color: #ffffff;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06),
    0 1px 2px rgba(15, 23, 42, 0.04);
  padding: 24px;
  display: flex;
  flex-direction: column;

  &--flush {
    padding: 0;

    .section-card__header,
    .section-card__body,
    .section-card__actions {
      padding-left: 24px;
      padding-right: 24px;
    }

    .section-card__header {
      padding-top: 24px;
    }

    .section-card__actions {
      padding-bottom: 24px;
    }
  }

  &__header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 20px;
  }

  &__heading {
    flex: 1;
    min-width: 0;
  }

  &__title {
    font-size: 18px;
    font-weight: 600;
    color: #0f172a;
    margin: 0;
    line-height: 1.3;
  }

  &__subtitle {
    font-size: 13px;
    color: rgba(15, 23, 42, 0.62);
    margin: 4px 0 0;
    line-height: 1.5;
  }

  &__header-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  &__body {
    flex: 1;
  }

  &__actions {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-top: 20px;
  }
}
</style>
